// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","h1":"Header_h1__l4vQ3","nav":"Header_nav__ZwnMZ"};